import { useNavigate } from "react-router-dom";
import { Leaf, Phone, Mail, MapPin, Clock } from "lucide-react";
import { scrollToSection } from "@/hooks/useLenis";
import { CONTACT } from "@/lib/content";

export const Footer = ({ onQuote }) => {
  const navigate = useNavigate();
  return (
    <footer data-testid="footer" className="bg-[#0B0F0C] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-6">
              <span className="grid place-items-center w-9 h-9 rounded-full bg-white/10">
                <Leaf className="w-4 h-4 text-[#00E676]" strokeWidth={2.4} />
              </span>
              <span className="font-display font-extrabold text-xl">
                CBA<span className="text-[#00E676]">Mowing</span>
              </span>
            </div>
            <p className="font-editorial text-3xl sm:text-4xl leading-tight max-w-md">
              Precision lawn care, done right every time.
            </p>
            <button
              data-testid="footer-cta-quote"
              onClick={onQuote}
              className="mt-8 inline-flex items-center rounded-full bg-[#00E676] text-[#0B0F0C] font-semibold px-6 py-3 hover:bg-white transition-colors duration-300"
            >
              Book Your Free Quote
            </button>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="font-mono-t text-[11px] uppercase tracking-widest text-[#9EB0A5] mb-5">Explore</p>
            <ul className="space-y-3 text-[#E8F0EB]">
              {[["Services","services"],["Before & After","before-after"],["Service Map","service-area"],["Manifesto","manifesto"]].map(([l,id])=>(
                <li key={id}>
                  <button data-testid={`footer-link-${id}`} onClick={()=>scrollToSection(id)} className="hover:text-[#00E676] transition-colors">{l}</button>
                </li>
              ))}
              <li><button onClick={()=>navigate("/about")} className="hover:text-[#00E676] transition-colors">About Us</button></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono-t text-[11px] uppercase tracking-widest text-[#9EB0A5] mb-5">Contact</p>
            <ul className="space-y-4 text-[#E8F0EB]">
              <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-[#00E676]" /> {CONTACT.phone}</li>
              <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-[#00E676]" /> {CONTACT.email}</li>
              <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[#00E676]" /> {CONTACT.area}</li>
              <li className="flex items-center gap-3"><Clock className="w-4 h-4 text-[#00E676]" /> {CONTACT.hours}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-sm text-[#9EB0A5]">
          <p>© {new Date().getFullYear()} CBA Mowing. All rights reserved.</p>
          <p className="font-mono-t text-[11px] uppercase tracking-widest">Satisfaction Guaranteed</p>
        </div>
      </div>
    </footer>
  );
};
